import React, { useEffect } from "react";
import AudienceByCityChart from "./AudienceByCityChart";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";

function AudienceByCity(props) {
    const chartLoading = props.chartDataLoading?.audience_metrics_by_city;
    const isNoData = props.pageStatus || Object.keys(props.chartData.audience_metrics_by_city || {}).length === 0;

    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);

    const emptyObject = () => {
        const chartData = props.chartData.audience_metrics_by_city || {};
        const chartDataLength = Object.keys(chartData).length === 0;
        return chartDataLength;
    };

    return (
        <>
            {chartLoading && <Loading />}
            {!emptyObject() && !chartLoading && (
                <AudienceByCityChart
                    chartData={props.chartData.audience_metrics_by_city}
                    graphType={props.graphType}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                />
            )}
            {emptyObject() && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}
export default AudienceByCity;
